// removed by extract-text-webpack-plugin
module.exports = {"main":"Title-main--O63Et"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapPanel/Title/Title.scss
// module id = FXLg
// module chunks = 4